<template>
    <img class="logo" src="../assets/LensAdvisors_cropped.svg" alt @click="$emit('click')" />
</template>

<script>
export default {
    name: 'LogoComponent'
}
</script>

<style lang="scss" scoped>
    img {
		cursor: pointer;
	}
</style>